import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({
  root: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    minHeight: '100%',
    overflow: 'hidden',
    background: 'linear-gradient(#1DB6FD, #230B4C);',
    zIndex: -1
  }
})
